module.exports = __webpack_public_path__ + "img/logo.45fa1bb1.png";